<template>
    <div class="inner__indent" >
        <div class="signup__title">Зарегистрироваться очень просто.<br>
            Это не займёт много времени.<br>
            Присоединяйтесь!</div>
        <div class="signup__form" >
            <form v-on:submit.prevent="submitForm" v-show="!submittedSucces">
                <div class="signup__left">
                    <div class="signup__input" v-bind:class="{'error-terms': errorFields.hasOwnProperty('fio')}">
                        <label for="">ФИО <span class="red-dot">*</span></label>
                        <input type="text" v-model="formData.fio" tabindex="1">
                    </div>
                    <div class="signup__input" v-bind:class="{'error-terms': errorFields.hasOwnProperty('phone') }">
                        <label for="">Телефон <span class="red-dot">*</span></label>
                        <input type="text" v-model="formData.phone" tabindex="3">
                    </div>
                    <div class="signup__input" v-bind:class="{'error-terms': errorFields.hasOwnProperty('region') }">
                        <label for="">Район <span class="red-dot">*</span></label>
                        <div class="select select" v-bind:class="{'is-open': showSelect }">
                            <span class="placeholder" v-on:click="switchSelect">{{formData.region?formData.region.title:"Выберите район..."}}</span>
                            <ul>
                                <li v-for="item in regions" :key="item.id" v-on:click="selectItem(item)">
                                    {{ item.title }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="signup__right">
                    <div class="signup__input">
                        <label for="">Компания</label>
                        <input type="text" v-model="formData.company" tabindex="2">
                    </div>
                    <div class="signup__input" v-bind:class="{'error-terms': errorFields.hasOwnProperty('email') }">
                        <label for="">E-mail <span class="red-dot">*</span></label>
                        <input type="email" v-model="formData.email" tabindex="4">
                    </div>
                    <div class="form__row__checkbox" v-bind:class="{'error-terms': errorFields.hasOwnProperty('terms') }">
                        <input type="checkbox" id="agree" name="agree" value="agree" v-model="terms">
                        <label for="agree">Согласен с условиями <a href="">Публичной оферты</a></label>
                    </div>
                </div>
                <div class="error-message">
                    <span v-if="Object.keys(errorFields).length">Пожалуйста, заполните обязательные поля.</span>
                    <span v-if="formSubmitted && !submittedSucces && !formLoading">Извините, возникла ошибка.</span>
                </div>
                <button class="signup__btn">Регистрация</button>
            </form>
            <h3 v-show="submittedSucces">Спасибо! Ваши данные отправлены.</h3>
        </div>
    </div>
</template>

<script>

    import { Api } from "../../components";

    export default {
        name: 'SignupPage',
        data: function () {
            return {
                showSelect: false,
                regions: [
                    {name: 'msk', title: 'Москва и Московская область'},
                    {name: 'spb', title: 'Санкт-Петербург и Ленинградская область'},
                    {name: 'smk', title: 'Смоленск и Смоленская область'},
                ],
                formData: {
                    fio: '',
                    phone: '',
                    company: '',
                    email: '',
                    region: '',
                },
                errorFields: {},
                formSubmitted: false,
                submittedSucces: false,
                terms: false,
                formLoading: false
            }
        },
        methods: {
            switchSelect: function () {
                this.showSelect = !this.showSelect;
            },
            selectItem: function (item) {
                this.showSelect = false;
                this.formData.region = item;
            },
            validateForm: function() {
                let validate = true;
                this.errorFields = {};
                Object.keys(this.formData).forEach( (elem) => {
                    if (elem === 'company') {
                        return;
                    }
                    if (!String(this.formData[elem]).trim().length) {
                        this.errorFields[elem] = true;
                        validate = false;
                    }
                });
                if (!this.terms) {
                    this.errorFields.terms = true;
                }
                return validate && this.terms;
            },
            submitForm: function () {
                if (!this.validateForm()) {
                    return;
                }
                this.formLoading = true;
                this.formSubmitted = true;
                const preparedData = Object.assign({}, this.formData,
                    {
                        region: this.formData.region.title
                    })
                Api.post('/register', preparedData)
                    .then(resp => {
                        this.submittedSucces = true;
                        this.formLoading = false;
                        //eslint-disable-next-line no-console
                        console.log(resp)
                    })
                    .catch(err => {
                        this.submittedSucces = false;
                        this.formLoading = false;
                        //eslint-disable-next-line no-console
                        console.log(err)
                    })
            }
        }
    }
</script>

<style scoped>
    .error-terms, .error-terms a, .error-terms label, .red-dot {
        color: red;
    }

    .error-terms.signup__input input, .error-terms.signup__input .placeholder {
        border-bottom: 1px solid red;
    }

    .error-terms.signup__input input:focus {
        border-bottom: 2px solid #d73056;
    }

    .error-message {
        clear: both;
        display: block;
        /*font-size: 24px;*/
        line-height: 32px;
        height: 32px;
        color: red;
    }
</style>
